import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { disableAllMenu } from 'modules/actions/statusMenu';
import { chatList, insertChat } from 'modules/actions/chat';

const SupportSystem = () => {
  const dispatch = useDispatch();

  const milType = useSelector(state => state.supportSystem.milType);
  const milName = useSelector(state => state.supportSystem.milName);

  const [option, setOption] = useState({
    mil_type: milName,
    sw_edu: '',
    sw_work: '',
    mil_term: '',
    persion: '',
    job_type: '',
    employ_type: '',
    duration: '',
  });
  const [params, setParams] = useState({
    active: false,
    soon: false,
    end: false,
  });

  useEffect(() => {
    if(milType === 'support_system_active' && option.sw_edu !== '' && option.mil_term !== '') {
      setParams({active: true})
    }else if(milType === 'support_system_soon' && option.sw_edu !== '' && option.mil_term !== '' && option.job_type !== '') {
      setParams({soon: true})
    }else if(milType === 'support_system_end' && option.sw_work !== '' && option.mil_term !== '' && option.job_type !== '') {
      if(option.job_type === '취·창업 중') {
        if(option.duration === '' || option.employ_type === '') {
          setParams({end: false})
        } else {
          setParams({end: true})
        }
      }else if(option.job_type === '민간부문 구직활동 중') {
        setParams({end: true})
      }
      if(option.employ_type === '기간제근로' && option.duration !== '') {
        setParams({end: true})
      }else if(option.employ_type === '정규직') {
        setParams({end: true})
      }
    }
  }, [option])

  const onOptionChage = e =>{   
    setOption((prevState) => {
      const temp = {};
      if(e.target.id === 'job_type1') {
        temp.employ_type = '';
        temp.duration = '';
      }
      if(e.target.id === 'employ_type1') { 
        temp.duration = '';
      }

      if(e.target.id === "milterm1") {
        temp.persion = "";
      }

      temp[e.target.name] = e.target.value;
      return {...prevState, ...temp};
    })
  }

  const closeModal = () => {
    dispatch(disableAllMenu());
  };

  const confirmEvt = async () => {
    if (!params.active && !params.soon && !params.end) return false;
    const loginYN = sessionStorage.getItem('mbrId') ? 'true' : 'false';
    const setParam = {
      user_id: sessionStorage.getItem('user_id'),
      inType: 'query',
      inStr: '맞춤 지원제도 찾기(' + milName + ') 결과보기',
      session_id: sessionStorage.getItem('session_id'),
      channel_id: sessionStorage.getItem('device'),
      parameters: { check_btn: 'Y', mbr_id: sessionStorage.getItem('mbrId'), login: loginYN, options: JSON.stringify(option)}
    };
    // console.log(setParam);
    dispatch(chatList(setParam));
    dispatch(disableAllMenu());
  };

  const radioStyle = {
    margin: "0px 10px 0px 5px",
    color: "#6B6B6B",
    fontWeight : "400",
    verticalAlign : "text-bottom"
  }
  const ActiveMil = () => {
    return (
      <div>
        <div> 
          <div className="fd_btn_text">1. 전직기본교육을 수료하셨나요?</div>
          <input type="radio" name="sw_edu" value="예" id="edu1" onChange={onOptionChage} checked={option.sw_edu === '예'}/>
          <label style={radioStyle} htmlFor="edu1">예</label>
          <input type="radio" name="sw_edu" value="아니오" id="edu2" onChange={onOptionChage} checked={option.sw_edu === '아니오'}/>
          <label style={radioStyle} htmlFor="edu2">아니오</label>
        </div>

        <div>
          <div className="fd_btn_text">2. 전역일까지 군 복무한 기간은 얼마인가요?</div>
          <input type="radio" name="mil_term" value="5년 미만" id="mil_term1" onChange={onOptionChage} checked={option.mil_term === '5년 미만'}/>
          <label style={radioStyle} htmlFor="mil_term1">5년 미만</label>
          <input type="radio" name="mil_term" value="5년 이상~10년 미만" id="mil_term2" onChange={onOptionChage} checked={option.mil_term === '5년 이상~10년 미만'}/>
          <label style={radioStyle} htmlFor="mil_term2">5년 이상~10년 미만</label>
          <input type="radio" name="mil_term" value="10년 이상" id="mil_term3" onChange={onOptionChage} checked={option.mil_term === '10년 이상'}/>
          <label style={radioStyle} htmlFor="mil_term3">10년 이상</label>
        </div>
        {
          milType === 'support_system_soon' && (
            <div>
              <div className="fd_btn_text">3. 현재 취·창업을 하셨나요?</div>
              <input type="radio" name="job_type" value="민간부문 구직활동 중" id="job_type1" onChange={onOptionChage} checked={option.job_type === '민간부문 구직활동 중'} />
              <label style={radioStyle} htmlFor="job_type1">민간부문 구직활동 중</label>
              <input type="radio" name="job_type" value="준비하지 않음" id="job_type2" onChange={onOptionChage} checked={option.job_type === '준비하지 않음'} />
              <label style={radioStyle} htmlFor="job_type2">준비하지 않음</label>
            </div>
          )
        }
      </div>
    )
  };

  const EndMil = () => {
    return (
      <div>
        <div className="fd_btn_text">1. 전역한지 얼마나 경과되셨나요?</div>
        <input type="radio" name="sw_work"  value="6개월 이내" id="sw_work1" onChange={onOptionChage} checked={option.sw_work === '6개월 이내'} />
        <label style={radioStyle} htmlFor="sw_work1">6개월 이내</label>
        <input type="radio" name="sw_work" value="3년 이내" id="sw_work2" onChange={onOptionChage} checked={option.sw_work === '3년 이내'} />
        <label style={radioStyle} htmlFor="sw_work2">3년 이내</label>
        <input type="radio" name="sw_work" value="3년 경과" id="sw_work3" onChange={onOptionChage} checked={option.sw_work === '3년 경과'} />
        <label style={radioStyle} htmlFor="sw_work3">3년 경과</label>

        <div className="fd_btn_text">2. 전역일까지 군 복무한 기간은 얼마인가요?</div>
        <input type="radio" name="mil_term" value="5년 미만" id="milterm1" onChange={onOptionChage} checked={option.mil_term === '5년 미만'}/>
        <label style={radioStyle} htmlFor="milterm1">5년 미만</label>
        <input type="radio" name="mil_term" value="5년 이상~10년 미만" id="milterm2" onChange={onOptionChage} checked={option.mil_term === '5년 이상~10년 미만'}/>
        <label style={radioStyle} htmlFor="milterm2">5년 이상~10년 미만</label>
        <input type="radio" name="mil_term" value="10년 이상" id="milterm3" onChange={onOptionChage} checked={option.mil_term === '10년 이상'}/>
        <label style={radioStyle} htmlFor="milterm3">10년 이상</label>

        <div className="fd_btn_text">3. 군인 연금 대상이 되나요?</div>
        <input type="radio" name="persion" value="연금 대상" id="persion1" onChange={onOptionChage} checked={option.persion === '연금 대상'}
          disabled={option.mil_term === "5년 미만"}/>
        <label style={radioStyle} htmlFor="persion1">군인 연금 대상</label>
        <input type="radio" name="persion" value="연금 비대상" id="persion2" onChange={onOptionChage} checked={option.persion === '연금 비대상'}
          disabled={option.mil_term === "5년 미만"}/>
        <label style={radioStyle} htmlFor="persion2">군인 연금 비대상</label>

        <div className="fd_btn_text">4. 현재 취·창업을 하셨나요?</div>
        <input type="radio" name="job_type" value="민간부문 구직활동 중" id="job_type1" onChange={onOptionChage} checked={option.job_type === '민간부문 구직활동 중'}/>
        <label style={radioStyle} htmlFor="job_type1">민간부문 구직활동 중</label>
        <input type="radio" name="job_type" value="취·창업 중" id="job_type2" onChange={onOptionChage} checked={option.job_type === '취·창업 중'}/>
        <label style={radioStyle} htmlFor="job_type2">취·창업 중</label>

        <div className="fd_btn_text">5. 고용의 형태는 무엇인가요?</div>
        <input type="radio" name="employ_type" value="정규직" id="employ_type1" onChange={onOptionChage} checked={option.employ_type === '정규직'} disabled={option.job_type === '민간부문 구직활동 중'}/>
        <label style={radioStyle} htmlFor="employ_type1">정규직<span style={{ fontSize: '10px' }}>(무기계약직 포함)</span></label>
        <input type="radio" name="employ_type" value="기간제근로" id="employ_type2" onChange={onOptionChage} checked={option.employ_type === '기간제근로'} disabled={option.job_type === '민간부문 구직활동 중'}/>
        <label style={radioStyle} htmlFor="employ_type2">기간제근로<span style={{ fontSize: '10px' }}>(창업,단기간,일용직 등)</span></label>

        <div className="fd_btn_text">6. 현 직장에서 연속적으로 근무한 기간은 얼마인가요?</div>
        <input type="radio" name="duration" value="2년 이내" id="duration1" onChange={onOptionChage} checked={option.duration === '2년 이내'} disabled={option.job_type === '민간부문 구직활동 중' || option.employ_type === '정규직'}/>
        <label style={radioStyle} htmlFor="duration1">2년 이내</label>
        <input type="radio" name="duration" value="2년 이상" id="duration2" onChange={onOptionChage} checked={option.duration === '2년 이상'} disabled={option.job_type === '민간부문 구직활동 중' || option.employ_type === '정규직'}/>
        <label style={radioStyle} htmlFor="duration2">2년 이상</label>
      </div>
    )
  };
  return (
    <div className="support_bg">
      <div className="support_area">

        <button type="button" aria-label="닫기" title="맞춤 지원제도 찾기 창 닫기" className="_close_btn_div" onClick={closeModal} >
          <i className="ri-close-line-2" />
        </button>
        <div className="fd_name fd_name_01">맞춤 지원제도 찾기({milName})</div>

        {milType === 'support_system_end' ? <EndMil /> : <ActiveMil />}

        <button type="button" title="결과보기 확인" className={`fd_send_btn ${params.active || params.soon || params.end ? '' : '_inactive' }`} onClick={() => confirmEvt()}>
          결과 보기
        </button>
      </div>
    </div>
  );
};

export default SupportSystem;
